import styled from '@emotion/styled'
import themeVars from 'ui_theme/site/globals/site.variables'

export default styled('span')`
  color: ${props => themeVars[props.color]};
`
